import { MapPin, Star, Users } from 'lucide-react';

const locations = [
  { name: 'Grand Ballroom', capacity: 500, rating: 4.8, address: '123 Main Street' },
  { name: 'Tech Center', capacity: 200, rating: 4.5, address: '456 Innovation Ave' },
  { name: 'Conference Room A', capacity: 50, rating: 4.2, address: '789 Business Blvd' },
  { name: 'Garden Terrace', capacity: 150, rating: 4.9, address: '321 Park Lane' },
];

export function Locations() {
  return (
    <div>
      <h1 className="text-2xl font-bold mb-2">Locations</h1>
      <p className="text-muted-foreground mb-8">Manage your event venues and locations.</p>

      <div className="grid gap-4 md:grid-cols-2">
        {locations.map((location) => (
          <div key={location.name} className="glass-card p-6 rounded-xl hover:border-primary/50 transition-all duration-300">
            <div className="flex items-start justify-between mb-4">
              <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
                <MapPin className="h-6 w-6 text-primary" />
              </div>
              <div className="flex items-center gap-1 text-yellow-500">
                <Star className="h-4 w-4 fill-current" />
                <span className="text-sm font-medium">{location.rating}</span>
              </div>
            </div>
            <h3 className="font-semibold mb-2">{location.name}</h3>
            <p className="text-sm text-muted-foreground mb-3">{location.address}</p>
            <div className="flex items-center gap-1 text-sm text-muted-foreground">
              <Users className="h-4 w-4" />
              <span>Capacity: {location.capacity}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
